import React from "react";
import {
  Box,
  Button,
  Modal,
  Typography,
  Tooltip,
  IconButton,
} from "@mui/material";
import Close from "@mui/icons-material/Close";
const { formatInTimeZone } = require("date-fns-tz");

const BadgeDetailsModal = ({
  open,
  event,
  ticketId,
  handleClose,
  handleClear,
}) => {
  const { tickets, timezone } = event || {};
  const ticket = (tickets || []).find(({ id }) => id === ticketId);
  const { badge } = ticket || {};

  if (!badge) {
    return null;
  }

  const { programmedAt } = badge;
  const datePattern = "M/d/yyyy h:mm a z";
  const dateText = formatInTimeZone(
    programmedAt.toDate(),
    timezone,
    datePattern,
  );

  return (
    <Modal open={open}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "100%", sm: "100%", md: 600 },
          bgcolor: "background.paper",
          border: "2px solid #000",
          boxShadow: 24,
          p: 4,
          maxHeight: "90vh",
          overflow: "auto",
        }}
      >
        <Box display={"flex"}>
          <Typography flexGrow={"1"} variant="h6">
            Badge
          </Typography>
          <Tooltip title="Close">
            <IconButton
              onClick={() => {
                handleClose();
              }}
            >
              <Close />
            </IconButton>
          </Tooltip>
        </Box>
        <Box marginTop={"20px"}>
          <Typography color={"primary.lightText"}>
            Badge Programed On:
          </Typography>
          <Box display={"flex"} alignItems={"center"}>
            <Typography sx={{ flex: 1 }}>{dateText}</Typography>
            <Button
              onClick={() => {
                handleClear(ticketId);
              }}
            >
              Clear
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default BadgeDetailsModal;
